// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1Rvjf","overflowing":"ReadFullNote_overflowing__VyXKO"};